document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.rec_menu');
  const drawerElement = document.querySelector('.rec_drawer');

  if (menuButton && drawerElement) {
    // 既存の開閉処理
    menuButton.addEventListener('click', (event) => {
      event.stopPropagation(); // 念のためイベント伝播を停止
      menuButton.classList.toggle('active');
      drawerElement.classList.toggle('open');
    });

    // ★ 追加する処理 ★
    // ドロワー内の要素がクリックされたとき、親要素へのイベント伝播を停止
    drawerElement.addEventListener('click', (event) => {
      // ドロワーの背景クリックなど、意図的に閉じる要素がクリックされた場合を除き
      // 内部のコンテンツクリックでドロワーが閉じないようにする
      event.stopPropagation();
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // すべてのクリック対象 (li.haschildren > span) を取得
  const toggleButtons = document.querySelectorAll('li.haschildren > span');

  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      const parentLi = button.closest('.haschildren'); // 親の<li>を取得
      const targetUl = button.nextElementSibling;       // 次の兄弟要素の<ul>を取得

      if (!parentLi || !targetUl) return; // 要素が取得できなければ何もしない

      // 既に開いているかどうかの判定
      const isOpen = parentLi.classList.contains('active');

      if (isOpen) {
        // 閉じるとき (Slide Up)
        slideUp(targetUl, 300); // 300msでスライドアップ
        parentLi.classList.remove('active');
      } else {
        // 開くとき (Slide Down)
        slideDown(targetUl, 300); // 300msでスライドダウン
        parentLi.classList.add('active');
      }
    });
  });
});

// --- スライドアニメーション関数 ---

/**
 * 要素をスライドアップ（非表示）するアニメーション
 * @param {HTMLElement} target - アニメーション対象の要素 (ul)
 * @param {number} duration - アニメーション時間 (ミリ秒)
 */
const slideUp = (target, duration = 300) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight; // リフローを強制
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  
  window.setTimeout( () => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

/**
 * 要素をスライドダウン（表示）するアニメーション
 * @param {HTMLElement} target - アニメーション対象の要素 (ul)
 * @param {number} duration - アニメーション時間 (ミリ秒)
 */
const slideDown = (target, duration = 300) => {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;

  if (display === 'none') display = 'block';

  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight; // リフローを強制
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};


document.addEventListener('DOMContentLoaded', () => {
  const faqQuestions = document.querySelectorAll('.faq_item_q');

  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answerElement = question.nextElementSibling;
      question.classList.toggle('active');

      if (answerElement && answerElement.classList.contains('faq_item_a')) {
        answerElement.classList.toggle('open');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  // 要素を二重にラップする関数
  const wrapElementDoubly = (element) => {
    // 既に二重に囲まれていないか確認（二重ラップ防止）
    if (element.parentNode && 
        element.parentNode.classList.contains('entry_button') &&
        element.parentNode.parentNode &&
        element.parentNode.parentNode.classList.contains('entry_button_wrap')) {
      return;
    }

    // 1. 内側の div.entry_button を作成
    const innerWrapper = document.createElement('div');
    innerWrapper.classList.add('entry_button');
    
    // 2. 外側の div.entry_button_wrap を作成
    const outerWrapper = document.createElement('div');
    outerWrapper.classList.add('entry_button_wrap');

    // input要素の親要素を取得
    const parent = element.parentNode;

    if (parent) {
      // 3. input要素をouterWrapperで置き換える
      parent.replaceChild(outerWrapper, element);
      
      // 4. outerWrapper の中に innerWrapper を配置
      outerWrapper.appendChild(innerWrapper);
      
      // 5. innerWrapper の中に input 要素を配置
      innerWrapper.appendChild(element);
    }
  };

  // 1. 既存の要素をチェックしてラップ
  const initialInputs = document.querySelectorAll('input.pico[type="submit"]');
  initialInputs.forEach(wrapElementDoubly);

  // 2. DOMの変化を監視
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // 要素ノードであることを確認
            // 新しく追加された要素自身が対象の場合
            if (node.matches('input.pico[type="submit"]')) {
              wrapElementDoubly(node);
            }
            
            // 新しく追加された要素の子要素に存在する場合
            const nestedInputs = node.querySelectorAll('input.pico[type="submit"]');
            nestedInputs.forEach(wrapElementDoubly);
          }
        });
      }
    });
  });

  // <body>要素を監視対象に設定
  observer.observe(document.body, { childList: true, subtree: true });
});